module.exports = __webpack_public_path__ + "img/pt_seguromovil.ced53ea6.png";